const config = {
  API_URL: process.env.REACT_APP_API_BASE_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  PROJECT_ID: process.env.REACT_APP_PROJECT_ID || "",
  GOOGLE_ANALYTICS_TRACKING_ID:
    process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID,
  ENV: process.env.REACT_APP_ENV,
  TRACKING_URL: process.env.REACT_APP_TRACKING_URL || "",
};

export default config;
